var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-item-group",
        {
          attrs: { value: _vm.l_value, multiple: _vm.multiple },
          on: { change: _vm.update }
        },
        [
          _vm.banner
            ? _vm._l(_vm.data, function(item, index) {
                return _c("v-item", {
                  key: index,
                  attrs: { value: item.valueMember },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var toggle = ref.toggle
                          return [
                            _c("poistenie-banner", {
                              attrs: {
                                value: item,
                                "data-id": _vm.l_dataId,
                                newId: _vm.pripad ? _vm.pripad.newId : "",
                                cisloPredmetu: _vm.cisloPredmetu,
                                select: function() {
                                  return _vm.onSelect(toggle, item)
                                },
                                "add-button": _vm.addButton,
                                isOlfs: _vm.isOlfs
                              },
                              on: {
                                addButtonClicked: function($event) {
                                  return _vm.addButtonClicked(item)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              })
            : [
                _c(
                  "v-row",
                  {
                    staticClass: "mx-n3 mt-n2 md-flex-column",
                    class: { "mb-3": !_vm.isMobile }
                  },
                  _vm._l(_vm.displayedData, function(item, index) {
                    return _c(
                      "v-col",
                      {
                        key: index,
                        staticClass: "pa-3",
                        attrs: { xl: "3", lg: "3", md: "4" }
                      },
                      [
                        _c("v-item", {
                          attrs: { value: item.valueMember },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var toggle = ref.toggle
                                  return [
                                    _c("poistenie-card", {
                                      attrs: {
                                        isSelected:
                                          _vm.getValue() == item.valueMember,
                                        value: item,
                                        "data-id": _vm.l_dataId,
                                        newId: _vm.pripad
                                          ? _vm.pripad.newId
                                          : "",
                                        cisloPredmetu: _vm.cisloPredmetu,
                                        select: function() {
                                          return _vm.onSelect(toggle, item)
                                        },
                                        "add-button": _vm.addButton,
                                        isOlfs: _vm.isOlfs
                                      },
                                      on: {
                                        addButtonClicked: function($event) {
                                          return _vm.addButtonClicked(item)
                                        }
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ]
        ],
        2
      ),
      _vm.isMobile && _vm.data.length > 3
        ? [
            _c("div", { staticClass: "poistenie-control-show-all" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.areItemsShown = !_vm.areItemsShown
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.areItemsShown ? "Zobraziť menej" : "Zobraziť všetky"
                      ) +
                      " "
                  ),
                  _c("v-icon", { class: { "rotate-180": _vm.areItemsShown } }, [
                    _vm._v("mdi-chevron-down")
                  ])
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }